import { render, staticRenderFns } from "./PhotoViewerPreview.vue?vue&type=template&id=a20955a6&scoped=true&"
import script from "./PhotoViewerPreview.vue?vue&type=script&lang=js&"
export * from "./PhotoViewerPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20955a6",
  null
  
)

export default component.exports